const getters = {
    userId: state => state.user.userId,            // 用户Id
    token: state => state.user.token,              // 用户登录token
    userType: state => state.user.userType,        // 用户类型，未知身份 0， 品牌商 1， 生产商 2  直播相关 9
    phone: state => state.user.phone,              // 用户手机号 - 用户账号
    userIsAuth: state => state.user.userIsAuth,           // 用户是否认证  y - 已认证  n - 被拒绝  p - 已提交资料待审核  never - 未提交资料
    useAuthRejectReason: state => state.user.useAuthRejectReason,  // 用户认证失败原因
    payIsAuth: state => state.user.payIsAuth,                      // 用户支付信息是否认证  y/n
    servicePhone: state => state.user.servicePhone,
    userInfo: state => state.user.userInfo                         // 个人信息
}
export default getters